import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../app/store";
import Cookies from "js-cookie";
import {jwtDecode} from "jwt-decode";

interface JwtPayload {
    exp: number; // expiration time in seconds
}

const ProtectedLayout = () => {
    const { isLoggedIn } = useAppSelector((state) => state.auth);
    const token = Cookies.get("token");

    let isTokenExpired = false;

    if (token) {
        try {
            const decoded = jwtDecode<JwtPayload>(token);
            const currentTime = Date.now() / 1000; // current time in seconds
            isTokenExpired = decoded.exp < currentTime;
        } catch (error) {
            isTokenExpired = true; // invalid token
        }
    }

    if (!isLoggedIn || !token || isTokenExpired) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedLayout;
